<template>
  <v-dialog
    class="v-dialogMembership"
    v-model="$store.state.workshop.membershipPaymentModal"
    :max-width="$store.state.isMobile ? '90%' : '850px'"
    max-height="90%"
    scrollable
    persistent
    v-if="plan"
  >
    <v-card>
      <v-btn
        style="position: absolute;right: 8px;top: 8px;"
        icon
        @click="
          () => {
            $store.state.workshop.buttonLoading = false;
            $store.state.workshop.membershipPaymentModal = false;
          }
        "
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text class="pa-0">
        <v-row class="ma-0">
          <v-col
            v-if="!$store.state.isMobile"
            cols="4"
            style="background: linear-gradient(329.84deg, #465BC8 -21.36%, #529CFF 110.63%);border-radius: 5px 0px 0px 5px;"
            align="left"
          >
            <v-img
              class="mt-4"
              max-width="137"
              max-height="87"
              contain
              src="@/assets/Eblity.svg"
            />

            <v-col class="intro-text px-0 mt-2">
              {{ plan.name }}
            </v-col>
            <v-col class="intro-text px-0 mt-4">
              {{ plan.currency_details.symbol }} {{ plan.price }}
            </v-col>

            <v-col class="px-0 mt-10">
              <v-row class="ma-0 check-text">
                <v-img
                  class="me-4"
                  max-width="20"
                  max-height="20"
                  src="@/assets/fancy-check.svg"
                />
                100+ Resources
              </v-row>
            </v-col>
            <v-col class="px-0">
              <v-row class="ma-0 check-text">
                <v-img
                  class="me-4"
                  max-width="20"
                  max-height="20"
                  src="@/assets/fancy-check.svg"
                />
                Student Success App
              </v-row>
            </v-col>
            <v-col class="px-0">
              <v-row class="ma-0 check-text">
                <v-img
                  class="me-4"
                  max-width="20"
                  max-height="20"
                  src="@/assets/fancy-check.svg"
                />
                Guided Mentorship
              </v-row>
            </v-col>
            <v-col class="px-0">
              <v-row class="ma-0 check-text">
                <v-img
                  class="me-4"
                  max-width="20"
                  max-height="20"
                  src="@/assets/fancy-check.svg"
                />
                Exclusive Community
              </v-row>
            </v-col>
          </v-col>
          <v-col cols="12" sm="8" class="pa-8">
            <!-- <div class="form-heading my-4">Select Payment Method</div>
            <div>
              <v-btn-toggle
                v-model="selectedPaymentMethod"
                mandatory
                style="width: 100%"
                active-class="active-paymentMethod"
              >
                <v-row class="ma-0">
                  <v-col
                    class="pl-0"
                    cols="6"
                    md="3"
                    :key="index"
                    v-for="(paymentMethod, index) in paymentMethodList"
                  >
                    <v-btn
                      :value="paymentMethod"
                      outlined
                      style="font-size: 14px;line-height: 19px;"
                      :style="
                        paymentMethod.name == selectedPaymentMethod.name
                          ? 'border-color: #506CFF!important;'
                          : null
                      "
                    >
                      <v-img
                        width="26"
                        height="21"
                        contain
                        v-bind:src="
                          require('@/assets/membership/' +
                            getImage(paymentMethod))
                        "
                      >
                      </v-img>
                      {{ paymentMethod.name }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-btn-toggle>
            </div> -->
            <v-form ref="paymentForm">
              <!-- <v-row v-show="selectedPaymentMethod.name == 'Bank'">
                <v-col
                  cols="12"
                  style="font-weight: 600;font-size: 14px;line-height: 19px;color: #333333;"
                >
                  Please Select Your Bank Account
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="selectedPayment"
                    :items="paymentMethod"
                    outlined
                    dense
                    label="Select your bank"
                    hide-details
                    return-object
                    :rules="[rules.required]"
                  >
                    <template v-slot:selection="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                        min-height="24px"
                        contain
                      />
                      {{ data.item.name }}
                    </template>
                    <template v-slot:item="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                      />
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  style="font-weight: 600;font-size: 14px;line-height: 19px;color: #333333;"
                >
                  To complete your payment, please follow the steps below:
                </v-col>
                <v-col cols="12">
                  <ul>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Redirect to Bank Login
                    </li>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Login to bank with Username and password
                    </li>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Complete payment with OTP
                    </li>
                  </ul>
                </v-col>
              </v-row> -->
              <v-row
                v-if="
                  selectedPaymentMethod.name == 'Card' &&
                    !isMembershipCheckoutEnable
                "
              >
                <v-col cols="12" class="form-heading">
                  Enter your card details
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="selectedPayment"
                    :items="paymentMethod"
                    outlined
                    dense
                    label="Select Preferred card"
                    hide-details
                    return-object
                    :rules="[rules.required]"
                  >
                    <template v-slot:selection="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                        min-height="24px"
                        contain
                      />
                      {{ data.item.name }}
                    </template>
                    <template v-slot:item="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                      />
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    label="Enter Card Number"
                    v-model="cardNumber"
                    type="number"
                    :rules="[
                      rules.required,
                      rules.matchRegex(cardNumberRegex, cardNumber),
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Expiry Date"
                    outlined
                    dense
                    hide-details
                    v-model="expiryDate"
                    :rules="[
                      rules.required,
                      rules.matchRegex(
                        '(0[1-9]|10|11|12)/[0-9]{2}$',
                        expiryDate
                      ),
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="CVV"
                    outlined
                    dense
                    hide-details
                    :rules="[
                      rules.required,
                      rules.matchRegex(cvvRegex, cardCvv),
                    ]"
                    v-model="cardCvv"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Account Holder First Name"
                    outlined
                    dense
                    hide-details
                    :rules="[rules.required, rules.notEmpty]"
                    v-model="holderFirstName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Account Holder Last Name"
                    outlined
                    dense
                    hide-details
                    :rules="[rules.required, rules.notEmpty]"
                    v-model="holderLastName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Full Address"
                    outlined
                    dense
                    hide-details
                    :rules="[rules.required, rules.notEmpty]"
                    v-model="address"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- <v-row v-show="selectedPaymentMethod.name == 'Cash'">
                <v-col
                  cols="12"
                  style="font-weight: 600;font-size: 14px;line-height: 19px;color: #333333;"
                >
                  The Selected Payment Method
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="selectedPayment"
                    :items="paymentMethod"
                    outlined
                    dense
                    label="The cash payment collection via pay"
                    hide-details
                    return-object
                    :rules="[rules.required]"
                  >
                    <template v-slot:selection="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                        min-height="24px"
                        contain
                      />
                      {{ data.item.name }}
                    </template>
                    <template v-slot:item="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                      />
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  style="font-weight: 600;font-size: 14px;line-height: 19px;color: #333333;"
                >
                  To complete your payment, please follow the steps below:
                </v-col>
                <v-col cols="12">
                  <ul>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Customer shows up at a BharatPay payment point
                    </li>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Customer asks the cashier for a Rapyd service payment
                    </li>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Customer presents the paycode
                    </li>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Customer delivers the amount of the collection in cash
                    </li>

                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Customer receives proof.
                    </li>
                    <li>
                      <div class="bullet">
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 32 32"
                          focusable="false"
                        >
                          <circle stroke="none" cx="16" cy="16" r="10"></circle>
                        </svg>
                      </div>
                      Note - For first cash payment on BharatPay terminals, PAN
                      card and passport may be required as well
                    </li>
                  </ul>
                </v-col>
              </v-row>

              <v-row v-show="selectedPaymentMethod.name == 'eWallet'">
                <v-col
                  cols="12"
                  style="font-weight: 600;font-size: 14px;line-height: 19px;color: #333333;"
                >
                  Please Select Your Preferred eWallet
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="selectedPayment"
                    :items="paymentMethod"
                    outlined
                    dense
                    label="Select payment method"
                    hide-details
                    return-object
                    :rules="[rules.required]"
                  >
                    <template v-slot:selection="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                        min-height="24px"
                        contain
                      />
                      {{ data.item.name }}
                    </template>
                    <template v-slot:item="data">
                      <v-img
                        class="mr-2"
                        :src="data.item.image"
                        max-width="24px"
                      />
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="12"
                  style="font-weight: 600;font-size: 14px;line-height: 19px;color: #333333;"
                >
                  To complete your payment, please follow the steps below:
                </v-col>
                <v-col cols="12">
                  <ul class="timeline">
                    <li><span>Redirect to Ewallet App.</span></li>
                  </ul>
                </v-col>
              </v-row> -->
              <div class="form-heading my-4">Membership Details</div>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="First Name"
                    outlined
                    dense
                    hide-details
                    :rules="[rules.required]"
                    v-model="firstName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Last Name"
                    outlined
                    dense
                    hide-details
                    :rules="[rules.required]"
                    v-model="lastName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Email"
                    outlined
                    dense
                    hide-details
                    :rules="[rules.required, rules.email]"
                    v-model="email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Mobile No."
                    outlined
                    dense
                    hide-details
                    :rules="[rules.required]"
                    v-model="mobile"
                  ></v-text-field>
                </v-col>
                <v-col class="12">
                  <v-btn
                    color="#506CFF"
                    dark
                    @click="makePayment"
                    :loading="payemntLoading"
                    style="font-weight: 800;font-size: 20px;line-height: 27px;width:100%; height:56px; border-radius: 8px;"
                  >
                    Make Payment
                  </v-btn>
                  <div
                    v-show="true"
                    class="pa-2"
                    id="paypal-div"
                    ref="paypal"
                  ></div>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import RapydPaymentApiHelper from "../../api/common/RapydApis";
  import RULES from "../../common/fieldRules";
  import Keys from "../../constants/keys";
  import { ROUTER_URL } from "../../constants/urls";
  import authToken from "../../common/authToken";
  import AmplitudeHelper from "../../amplitude";
  import store from "../../store";
  import UserApiHelper from "../../api/common/UserApis";
  import PaymentApiHelper from "../../api/common/PaymentApis";

  export default {
    name: "MembershipPaymentModal",
    props: ["workshopId"],
    components: {},
    data() {
      return {
        paymentMethod: [],
        selectedPaymentMethod: {
          name: "Card",
          icon: "creditCardInactive.svg",
          iconActive: "creditCardActive.svg",
        },
        paymentMethodList: [
          // {
          //   name: "Bank",
          //   icon: "bankInactive.svg",
          //   iconActive: "bankActive.svg",
          // },
          {
            name: "Card",
            icon: "creditCardInactive.svg",
            iconActive: "creditCardActive.svg",
          },
          // {
          //   name: "Cash",
          //   icon: "cashInactive.svg",
          //   iconActive: "cashActive.svg",
          // },
          // {
          //   name: "eWallet",
          //   icon: "walletInactive.svg",
          //   iconActive: "walletActive.svg",
          // },
        ],

        loading: true,
        // payemntLoading: false,
        selectedPayment: null,
        requiredFields: [],
        rules: RULES,

        cardNumber: null,
        expiryDate: null,
        cardCvv: null,
        holderFirstName: null,
        holderLastName: null,

        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        address: null,

        cvvRegex: null,
        cardNumberRegex: null,
      };
    },
    created() {
      // this.selectedPaymentMethod = 0;
      this.firstName =
        authToken.decodedToken().first_name == undefined
          ? null
          : authToken.decodedToken().first_name;
      this.lastName =
        authToken.decodedToken().last_name == undefined
          ? null
          : authToken.decodedToken().last_name;
      this.email =
        authToken.decodedToken().email == undefined
          ? null
          : authToken.decodedToken().email;
      this.mobile =
        authToken.decodedToken().mobile == undefined
          ? null
          : authToken.decodedToken().mobile;
    },
    computed: {
      payemntLoading() {
        return this.$store.state.workshop.buttonLoading;
      },
      plan() {
        return this.$store.state.workshop.selectedPlan;
      },
      dialogState() {
        return this.$store.state.workshop.membershipPaymentModal;
      },
      isLoggedIn() {
        return this.$store.state.isLoggedIn || authToken.isCorrectAccessToken();
      },
      isMembershipCheckoutEnable: {
        get() {
          return this.$store.state.membership.isMembershipCheckoutEnable;
        },
        set(value) {
          store.dispatch("membership/updateMembershipCheckoutEnable", value);
        },
      },
      membershipPaymentModal: {
        get() {
          return this.$store.state.workshop.isMembershipCheckoutEnable;
        },
        set(value) {
          store.dispatch("workshop/updateMembershipPaymentModal", value);
        },
      },
    },
    watch: {
      selectedPayment() {
        this.getPaymentMethodRequiredFields();
      },
      expiryDate(val) {
        switch (val.length) {
          case 2:
            this.expiryDate = this.expiryDate + "/";
            break;
        }
      },
      dialogState(newState, oldState) {
        // this.$store.state.workshop.buttonLoading = true;
        this.firstName =
          authToken.decodedToken().first_name == undefined
            ? null
            : authToken.decodedToken().first_name;
        this.lastName =
          authToken.decodedToken().last_name == undefined
            ? null
            : authToken.decodedToken().last_name;
        this.email =
          authToken.decodedToken().email == undefined
            ? null
            : authToken.decodedToken().email;
        this.mobile =
          authToken.decodedToken().mobile == undefined
            ? null
            : authToken.decodedToken().mobile;
        this.getPaymentMethods();
        if (newState == false && !this.isLoggedIn) this.clearForm();
      },
      membershipPaymentModal() {
        const script = document.createElement("script");
        script.src =
          "https://www.paypal.com/sdk/js?currency=" +
          this.plan.currency_details.currency_code +
          "&client-id=" +
          process.env.VUE_APP_PAYPAL_CLIENT_ID +
          "&disable-funding=credit,card";
        console.log(script);
        script.addEventListener("load", this.setLoaded);
        document.body.appendChild(script);
      },
    },
    methods: {
      getImage(paymentMethod) {
        return paymentMethod.name == this.selectedPaymentMethod.name
          ? paymentMethod.iconActive
          : paymentMethod.icon;
      },
      getFieldText(item) {
        return `<v-img
                        class="mr-2"
                        :src="${item.image}"
                        max-width="24px"
                      />${item.name}`;
      },
      getPaymentMethods() {
        this.loading = true;
        const successHandler = (res) => {
          console.log(res);
          this.loading = false;
          this.paymentMethod = JSON.parse(res.data.data).data.filter(function(
            item
          ) {
            return item.category == "card";
          });
          console.log(this.paymentMethod, "11111");
        };

        const failureHandler = (res) => {
          console.log(res);
          this.loading = false;
        };
        RapydPaymentApiHelper.getPaymentMethods(successHandler, failureHandler);
      },
      getPaymentMethodRequiredFields() {
        const successHandler = (res) => {
          console.log(res);
          console.log(JSON.parse(res.data.data).data.fields);
          this.requiredFields = JSON.parse(res.data.data).data.fields.filter(
            function(item) {
              return item.is_required;
            }
          );

          this.cvvRegex = this.requiredFields.filter(function(item) {
            return item.name == "cvv";
          })[0].regex;

          this.cardNumberRegex = this.requiredFields.filter(function(item) {
            return item.name == "number";
          })[0].regex;
        };

        const failureHandler = (res) => {
          console.log(res);
        };

        RapydPaymentApiHelper.getPaymentMethodRequiredFields(
          this.selectedPayment.type,
          successHandler,
          failureHandler
        );
      },
      makePayment() {
        if (this.$refs.paymentForm.validate()) {
          this.$store.state.workshop.buttonLoading = true;
          console.log(this.plan);

          let params = {};
          if (!this.isMembershipCheckoutEnable) {
            var arr = this.expiryDate.split("/");
            params[Keys.RAPYD_PAY_METHOD_NAME] = this.selectedPayment.type;
            params[Keys.RAPYD_PAY_FIELDS] = {
              number: this.cardNumber,
              expiration_month: arr[0],
              expiration_year: arr[1],
              cvv: this.cardCvv,
              name: this.holderFirstName + " " + this.holderLastName,
            };
            params[Keys.ADDRESS] = this.address;
          }

          params[Keys.WORKSHOP_ID] = this.workshopId;
          params[Keys.MEMBERSHIP_PLAN_ID] = this.plan.id;

          params[Keys.FIRST_NAME] = this.firstName;
          params[Keys.LAST_NAME] = this.lastName;
          params[Keys.EMAIL] = this.email;
          params[Keys.MOBILE] = this.mobile;

          const successHandler = (res) => {
            console.log(res);
            // this.$store.state.workshop.buttonLoading = false;

            if (this.isMembershipCheckoutEnable) {
              // console.log(res.data);
              window.location.replace(res.data.payment_redirect_url);
            } else {
              this.$store.state.membership.userMembership = res.data.data;

              this.$router.push({
                name:
                  ROUTER_URL.publicMembership.children.membershipThankYou.name,
              });
            }

            AmplitudeHelper.registerEvent(
              "Membership - Make Payment - Success",
              params
            );
          };

          const failureHandler = (res) => {
            console.log(res);
            this.$store.state.workshop.buttonLoading = false;
            AmplitudeHelper.registerEvent(
              "Membership - Make Payment - Failure",
              params
            );
          };

          // RapydPaymentApiHelper.createSubscriptionPayment(
          //   params,
          //   successHandler,
          //   failureHandler
          // );

          UserApiHelper.makeMembershipOrderId(
            this.workshopId,
            this.plan,
            this.firstName,
            this.lastName,
            this.email,
            this.mobile
          );
        }
      },
      clearForm() {
        this.$refs.paymentForm.reset();
        this.loading = true;
        this.$store.state.workshop.buttonLoading = false;
        this.selectedPayment = null;
        this.cardNumber = null;
        this.expiryDate = null;
        this.cardCvv = null;
        this.holderFirstName = null;
        this.holderLastName = null;
        this.firstName = null;
        this.lastName = null;
        this.email = null;
        this.mobile = null;
        this.address = null;
        this.cvvRegex = null;
        this.cardNumberRegex = null;
      },
      setLoaded: function() {
        this.loaded = true;
        window.paypal
          .Buttons({
            createOrder: (data, actions) => {
              let purchase_unit = [
                {
                  description: this.isMembershipSelected
                    ? this.membershipDetails.name
                    : this.workshopDetails.title,
                  amount: {
                    currency_code: this.workshopDetails.country_details
                      .currency_code,
                    value: this.isMembershipSelected
                      ? this.membershipDetails.price
                      : this.workshopDetails.amount,
                  },
                },
              ];

              console.log(purchase_unit);

              return actions.order.create({
                purchase_units: purchase_unit,
              });
            },
            onApprove: async (data, actions) => {
              const order = await actions.order.capture();
              console.log(order);
              console.log(data.orderID);
              let requestParams = {
                membership_plan_id: this.plan.id,
                paypal_order_id: data.orderID,
              };

              this.verifyingPaypalPayemnt = true;
              const successHandler = (res) => {
                store.state.membership.userMembership = res.data.data;

                this.$router.push({
                  name:
                    ROUTER_URL.publicMembership.children.membershipThankYou
                      .name,
                });
              };
              const failureHandler = (res) => {
                console.log(res);
                this.verifyingPaypalPayemnt = false;
              };
              PaymentApiHelper.verifyPayPalPayment(
                requestParams,
                successHandler,
                failureHandler
              );
            },
            onError: (err) => {
              console.log(err);
            },
            style: {
              label: "pay",
              height: 40,
              Tagline: true,
            },
          })
          .render(this.$refs.paypal);
      },
    },
    mounted() {
      // this.getPaymentMethods();
    },
  };
</script>

<style scoped>
  .intro-text {
    font-weight: 900;
    font-size: 24px;
    line-height: 33px;

    color: rgba(255, 255, 255, 0.87);
  }

  .check-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

    color: rgba(255, 255, 255, 0.87);
  }

  .form-heading {
    font-weight: 800;
    font-size: 22px;
    line-height: 30px;
    /* identical to box height */

    color: #333333;
  }

  /* No normal bullets please */
  ul {
    list-style-type: none;
  }

  li {
    /* You need to turn on relative positioning so the line is placed relative to the item rather than absolutely on the page */
    position: relative;

    /* Use padding to space things out rather than margins as the line would get broken up otherwise */
    margin: 0;
    padding-bottom: 1em;
    padding-left: 20px;
    z-index: 1;
  }

  /* The actual line being placed before each list item, tweak width and color as appropriate */
  li:before {
    background-color: #dde8ff;
    width: 2px;
    content: "";
    position: absolute;
    top: 0px;
    bottom: -10px;
    left: 2px;
    z-index: -1;
  }

  /* Start the line further down on the first list item */
  li:first-child:before {
    top: 12px;
  }

  /* Stop the line short on the final list item */
  li:last-child:before {
    height: 6px;
  }

  /* Styles for the SVG bullet points */
  .bullet {
    margin-left: -21px;
    width: 18px;
    fill: #9eb8f0;
    float: left;
    padding-right: 10px;
  }

  .active-paymentMethod {
    background: linear-gradient(
        0deg,
        rgba(80, 108, 255, 0.04),
        rgba(80, 108, 255, 0.04)
      ),
      #ffffff !important;
    border: 2px solid #506cff !important;
    border-radius: 3.5px;
    font-weight: 800;
    font-size: 14px;
    line-height: 19px;

    color: #506cff;
  }
</style>
